import { useNavigate } from "react-router-dom";

type AppBarProps = {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  right?: React.ReactNode;
};

export function AppBar({ title, showBack, onBack, right }: AppBarProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-2 border-b border-[var(--line-soft)] bg-paper-warm/95 px-5 backdrop-blur-sm">
      {showBack ? (
        <button
          type="button"
          onClick={handleBack}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-forest-700"
          aria-label="返回"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M12 4L6 10l6 6"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ) : (
        <div className="w-9 shrink-0" />
      )}
      <h1 className="flex-1 truncate text-center text-[15px] font-semibold text-ink-900">
        {title}
      </h1>
      <div className="flex w-9 shrink-0 justify-end">{right}</div>
    </header>
  );
}
